// extracted by mini-css-extract-plugin
module.exports =  {"checkbox-wrapper":"_32bbee5fda--checkbox-wrapper--ovQyh","focused":"_32bbee5fda--focused--VEc4h"};